'use strict';

import View from '../../../Pandora/model/view';

export class GroupingPanelService {
	static $inject = ['mx.shell.EventService', 'mx.shell.ExtraPanelManager'];

	constructor(eventService, extraPanelManager) {
		this.eventService = eventService;
		this.extraPanelManager = extraPanelManager;
	}

	open(groupingPreprocessor) {
		if (this._currentGroupingPreprocessor !== groupingPreprocessor) {
			this._groupingView = null;
		}

		this._groupingView =
			this._groupingView ||
			new View({
				id: 'view-group-by',
				locals: {
					groupingPreprocessor: groupingPreprocessor,
				},
				controller: 'mx.SolutionBuilderAgent.ViewGroupByController',
				templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-view-group-by/mx-view-group-by.html',
			});

		this._currentGroupingPreprocessor = groupingPreprocessor;

		if (this.extraPanelManager.view !== this._groupingView) {
			this.extraPanelManager.open(this._groupingView);
		}
	}

	close() {
		if (this.extraPanelManager.view === this._groupingView && this.extraPanelManager.visible) {
			this.extraPanelManager.close();
		}
		this._groupingView = null;
		this._currentGroupingPreprocessor = null;
	}

	isActive() {
		return this._groupingView && this.extraPanelManager.view === this._groupingView;
	}
}
